// In production, use relative URLs so all API calls go through the Vercel
// rewrite proxy (/api/* → Railway). This keeps everything same-origin:
// cookies work without cross-origin issues, no CORS preflight needed.
// The Vercel rewrite is configured in vercel.json.
export const API_BASE = '';
